import React, { Component } from 'react'
import { Table, Tooltip, Modal, Form, Button, Input, message, Select, Radio, Checkbox } from 'antd'
import { connect } from 'dva'
import { Link } from 'dva/router'
import { all, create } from '../../services/restApi'
import InfiniteScroll from '@fand/react-infinite-scroll-container';
import config from '../../utils/config'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const confirm = Modal.confirm
const FormItem = Form.Item;
const TextArea = Input.TextArea;
const Option = Select.Option;
const ButtonGroup = Button.Group;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group

class paymentType extends Component {

    constructor (props) {
        super(props);

        this.state = {
            hotels: [],
            parents_payments: [],
            query: {}
        };

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        // Query
        let query = {};
        if (this.state.currentHotel)
            query.objectId = this.state.currentHotel.objectId
        
        if (this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        // Consulta los hoteles
        all('Hotel', {where: query, limit: 20}).then((resp) => {
            if (this.state.currentHotel) 
                this.props.form.setFieldsValue({hotel: {key: this.state.currentHotel.objectId, label: this.state.currentHotel.name}});

            this.setState({ hotels: resp.results });
        })

        // Consulta las categorías principales del hotel asignado al gerente o recepcionista
        if (this.state.currentHotel) {
            all('PaymentType', {
                where: {
                    type: 'principal', 
                    hotel: {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}
                }, 
                limit: 20
            }).then((resp) => {
                this.setState({ parents_payments: resp.results });
            })
        }

        this.firstLoad();
    }


    /**
    * Primera carga
    */
    firstLoad (hasFilter) {
        this.props.dispatch({ type: 'app/showLoadingTable' })

        let query = {type: 'principal'};

        // hasFilter viene al crear o actualizar un registro, trae el hotel que se encuentra en el select para mantener el filtro
        if (hasFilter)
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: hasFilter}
        
        if (this.props.app.user.type === 'gerente') {
            query.hotel = {$in: this.props.app.user.hotels}
        }

        if (this.state.currentHotel)
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}

        all('PaymentType', {
            where: query,
            include: 'hotel,parent_category', 
            skip: 0, 
            limit: this.props.paymentType.limit,
            count: 1, 
            order: '-createdAt'
        }).then(resp => {

            if (resp.results.length > 0) {
            const paymentTypes = [];
                resp.results.map((item, key) => {

                    return all('PaymentType', {
                        where: {
                            parent_category: {__type: 'Pointer', className: 'PaymentType', objectId: item.objectId}
                        },
                        include: 'hotel,parent_category'
                    }).then(payments => {
                        if (payments.results.length > 0)
                            item.children = payments.results;

                        paymentTypes.push(item);

                        if (key === resp.results.length - 1) {
                            setTimeout(function() {
                                this.props.dispatch({ type: 'app/hideLoadingTable' })
                                this.props.dispatch({type: 'paymentType/queryFirst', payload: {
                                    paymentTypes: paymentTypes, 
                                    skip: 0, 
                                    limit: this.props.paymentType.limit,
                                    total_items: resp.count,
                                }})
                            }.bind(this), 100);
                        }
                    });
                });

            } else {
                this.props.dispatch({ type: 'app/hideLoadingTable' })
            }
        });
    }


    /**
    * Carga más registros
    */
    loadMore () {
        if (this.props.paymentType.skip < this.props.paymentType.total_items) {
            this.props.dispatch({ type: 'app/showLoadingTable' })

            let query = {...this.state.query};
            if (this.state.currentHotel)
                query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}

            if (this.props.app.user.type === 'gerente') {
                query.hotel = {$in: this.props.app.user.hotels}
            }

            all('PaymentType', {
                where: query,
                include: 'hotel,parent_category', 
                skip: this.props.paymentType.skip, 
                limit: this.props.paymentType.limit,
                count: 1, 
                order: '-createdAt'
            }).then(resp => {

                const paymentTypes = [];
                resp.results.map((item, key) => {

                    return all('PaymentType', {
                        where: {
                            parent_category: {__type: 'Pointer', className: 'PaymentType', objectId: item.objectId}
                        },
                        include: 'hotel,parent_category'
                    }).then(payments => {
                        if (payments.results.length > 0)
                            item.children = payments.results;

                        paymentTypes.push(item);

                        if (key === resp.results.length - 1) {

                            setTimeout(function() {
                                this.props.dispatch({ type: 'app/hideLoadingTable' })
                                this.props.dispatch({type: 'paymentType/querySuccess', payload: {
                                    paymentTypes: paymentTypes, 
                                    skip: this.props.paymentType.skip, 
                                    limit: this.props.paymentType.limit,
                                    total_items: resp.count,
                                }})
                            }.bind(this), 100);
                        }
                    });
                });
            });
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetch (value, callback) {
        let query = {};
        query.name = {$regex: '(?i)' + value};
        
        if (this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        setTimeout(() => {
            all('Hotel', {where: {name: {$regex: '(?i)' + value}}}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        if (value && value.key && !value.label) {
            this.fetch(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Categoría principal (Expense principal)
    */
    fetchExpense (value, callback) {

        if (this.props.form.getFieldValue('hotel')) {
            let query = {name: {$regex: '(?i)' + value}};
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.props.form.getFieldValue('hotel').key}

            setTimeout(() => {
                all('PaymentType', {where: query}).then((d) => {
                    const results = d.results;
                    const parents_payments = [];
                    
                    results.forEach((r) => {
                        parents_payments.push({
                            objectId: r.objectId,
                            name: r.name,
                        });
                    });

                    callback(parents_payments);
                });
            }, 500);
        }
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectExpenseChange (value) {
        if (value && value.key && !value.label) {
            this.fetchExpense(value.key, (resp) => {
                this.setState({ parents_payments: resp })
            });
        }
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkHotel (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el hotel!');
        } else {
            // Consulta las categorías principales del hotel en el select
            all('PaymentType', {
                where: {
                    type: 'principal', 
                    hotel: {__type: 'Pointer', className: 'Hotel', objectId: value.key}
                }, 
                limit: 20
            }).then((resp) => {
                this.setState({ parents_payments: resp.results });
            })

            this.search(value)
            callback();
        }
    }

    /**
    * Validator: Checa que se haya elegido un movimiento principal de la lista
    */
    checkType (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija la categoría principal!');
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que el monto sea mayor a 0
    */
    checkPrice (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.]/g, '')) === 0) {
            callback('Por favor, ingrese un monto correcto!');
        } else {
            callback();
        }
    } 


    /**
    * Búsqueda
    */
    search (value) {
        let query = this.state.query;
        query.type = 'principal';

        // Query
        if (value && value.key) {
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: value.key};
        }

        this.setState({query: query});
        this.props.dispatch({ type: 'app/showLoadingTable' })
        this.props.dispatch({type:'paymentType/filterSuccess', 
            payload: {
                paymentTypes: [], 
                limit: 0, 
            }
        });

        all('PaymentType', {
            where: query,
            include: 'hotel', 
            skip: 0, 
            limit: this.props.paymentType.limit,
            count: 1, 
            order: '-createdAt'
        }).then(resp => {

            if (resp.results.length > 0) {
                const paymentTypes = [];
                resp.results.map((item, key) => {

                    return all('PaymentType', {
                        where: {
                            parent_category: {__type: 'Pointer', className: 'PaymentType', objectId: item.objectId}
                        },
                        include: 'hotel,parent_category'
                    }).then(payments => {
                        if (payments.results.length > 0)
                            item.children = payments.results;

                        paymentTypes.push(item);

                        if (key === resp.results.length - 1) {

                            setTimeout(function() {
                                this.props.dispatch({ type: 'app/hideLoadingTable' })
                                this.props.dispatch({type: 'paymentType/filterSuccess', payload: {
                                    paymentTypes: paymentTypes, 
                                    skip: 0, 
                                    limit: this.props.paymentType.limit,
                                    total_items: resp.count,
                                }})
                            }.bind(this), 100);
                        }
                    });
                });
            } else {
                this.props.dispatch({ type: 'app/hideLoadingTable' })
            }
        });
    }


    /**
    * Elimina un registro
    */
    delete_item (item) {
        this.setState({currentExpense: ''});
        let dispatch = this.props.dispatch

        if (this.state.currentHotel)
            this.props.form.resetFields(['name', 'description']);
        else
            this.props.form.resetFields();

        confirm({
            title: '¿Estás seguro que deseas eliminar el movimiento?',
            onOk () {
                dispatch({type: 'paymentType/removeItem', payload: item});
            }
        })
    }


    /**
    * Establece el registro para editar
    */
    setUpdate (item) {
        this.setState({currentExpense: item.objectId});

        let obj = {...item};
        obj.allow = [];

        if (obj.hotel) obj.hotel = {key: obj.hotel.objectId, label: obj.hotel.name};
        if (obj.parent_category) obj.parent_category = {key: obj.parent_category.objectId, label: obj.parent_category.name};
        if (obj.allow_income) obj.allow.push('Ingreso');
        if (obj.allow_expense) obj.allow.push('Gasto');

        this.props.form.setFieldsValue({type: obj.type});

        setTimeout(function() {
            this.props.form.setFieldsValue(obj);
            window.scrollTo(0, 0)
        }.bind(this), 100);
    }


    /**
    * Cancela la edición
    */
    cancel_update () {
        this.setState({currentExpense: ''});
                                                    
        if (this.state.currentHotel)
            this.props.form.resetFields(['name', 'description']);
        else
            this.props.form.resetFields();
    }


    /**
    * Envío del formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            let data = {...values};
            data.hotel = {__type: 'Pointer', className: 'Hotel', objectId: values.hotel.key};
            data.allow_income = values.allow.indexOf('Ingreso') === -1 ? false : true;
            data.allow_expense = values.allow.indexOf('Gasto') === -1 ? false : true;
            values.omit ? data.omit = true : data.omit = false;

            if (values.parent_category) {
                data.parent_category = {__type: 'Pointer', className: 'PaymentType', objectId: values.parent_category.key};
            } else {
                data.parent_category = undefined;
            }

            data = _.omit(data, ['allow']);
            
            if (!this.state.currentExpense) {
                // CREA
                
                this.props.dispatch({type: 'app/showButtonLoading'})

                create('PaymentType', data).then(resp => {

                    resp.hotel = {objectId: values.hotel.key, name: values.hotel.label};
                    _.extend(data, resp);

                    this.props.dispatch({type: 'app/hideButtonLoading'})
                    message.success('Se ha creado el movimiento exitosamente');

                    this.props.dispatch({type: 'paymentType/createSuccess', payload: data})
                    this.firstLoad(resp.hotel.objectId);

                    this.props.form.resetFields(['name', 'description']);

                    // Si es categoría principal, entonces la agregamos al instante al array de payments_options
                    if (data.type === 'principal') {
                        this.setState({ parents_payments: [...this.state.parents_payments, data] });
                    }

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                data.objectId = this.state.currentExpense;
                data.hotel = {objectId: values.hotel.key, name: values.hotel.label};

                if (data.parent_category)
                    data.parent_category = {objectId: values.parent_category.key, name: values.parent_category.label};

                this.props.dispatch({type: 'paymentType/update', payload: data})
                this.firstLoad(data.hotel.objectId);

                this.setState({currentExpense: ''});
                this.props.form.resetFields(['name', 'description']);
            }
        })
    }

    render () {
        const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)
        const payments_options = this.state.parents_payments.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>Tipo de Movimientos</h1>
                </section>

                <section className="content">
                    <div className="row">
                        <div className="col-md-4">
                            <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>

                                <div className="box-body">
                                    <Form onSubmit={this.handleSubmit.bind(this)}>
                                        <div className="row">
                                            <div className="col-md-12">
                                                <FormItem label="Elija el Hotel" hasFeedback>
                                                    {this.props.form.getFieldDecorator('hotel', {
                                                        rules: [{
                                                            required: true,
                                                            message: 'Por favor, elija el hotel',
                                                        }, {
                                                            validator: this.checkHotel.bind(this)
                                                        }]
                                                    })(
                                                        <Select 
                                                            size='large'
                                                            mode="combobox"
                                                            onChange={this.handleSelectHotelChange.bind(this)}
                                                            filterOption={false}
                                                            labelInValue={true}
                                                            optionLabelProp='label'
                                                            >
                                                            {hotel_options}
                                                        </Select>
                                                    )}
                                                </FormItem>
                                            </div>

                                            <div className="col-md-12">
                                                <FormItem label="Jerarquía" hasFeedback>
                                                    {this.props.form.getFieldDecorator('type', {
                                                        initialValue: 'principal',
                                                        rules: [{
                                                            required: true,
                                                            message: 'Por favor, elija el tipo'
                                                        }]
                                                    })(
                                                        <RadioGroup onChange={this.onChangeType}>
                                                            <Radio value="principal">Categoría principal</Radio>
                                                            <Radio value="secundario">Sub-categoría</Radio>
                                                        </RadioGroup>
                                                    )}
                                                </FormItem>
                                            </div>

                                            {this.props.form.getFieldValue('type') && this.props.form.getFieldValue('type') === 'secundario'
                                                ? <div className="col-md-12">
                                                    <FormItem label="Categoría principal" hasFeedback>
                                                        {this.props.form.getFieldDecorator('parent_category', {
                                                            rules: [{
                                                                required: true,
                                                                message: 'Por favor, elija la categoría principal',
                                                            }, {
                                                                validator: this.checkType.bind(this)
                                                            }]
                                                        })(
                                                            <Select 
                                                                size='large'
                                                                mode="combobox"
                                                                onChange={this.handleSelectExpenseChange.bind(this)}
                                                                filterOption={false}
                                                                labelInValue={true}
                                                                optionLabelProp='label'
                                                                >
                                                                {payments_options}
                                                            </Select>
                                                        )}
                                                    </FormItem>
                                                </div>
                                                : ''
                                            }

                                            <div className="col-md-12">
                                                <FormItem label="Nombre" hasFeedback>
                                                    {this.props.form.getFieldDecorator('name', {
                                                        rules: [{
                                                            required: true,
                                                            message: 'Por favor, ingrese el nombre del movimiento'
                                                        }]
                                                    })(<Input size='large' placeholder="Nombre del movimiento" />)}
                                                </FormItem>
                                            </div>

                                            <div className="col-md-12">
                                                <FormItem label="Permitir" hasFeedback>
                                                    {this.props.form.getFieldDecorator('allow', {
                                                        initialValue: ['Ingreso', 'Gasto'],
                                                        rules: [{
                                                            required: true,
                                                            message: 'Por favor, elija una opción'
                                                        }]
                                                    })(<CheckboxGroup options={['Ingreso', 'Gasto']} />)}
                                                </FormItem>
                                            </div>

                                            <div className="col-md-12">
                                                <FormItem label="Ocultar en Estado de Resultados" hasFeedback>
                                                    {this.props.form.getFieldDecorator('omit')(
                                                        <Checkbox checked={this.props.form.getFieldValue('omit')}>Ocultar</Checkbox>
                                                    )}
                                                </FormItem>
                                            </div>

                                            {/*<div className="col-md-12">
                                                <FormItem label="Breve descripción" hasFeedback>
                                                    {this.props.form.getFieldDecorator('description')(<TextArea rows={4} />)}
                                                </FormItem>
                                            </div>*/}
                                        </div>

                                        <div className="row text-center paddingBottom30">
                                            <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'} style={{marginRight: '10px'}}>
                                                {!this.state.currentExpense ? 'Guardar' : 'Actualizar'}
                                            </Button>

                                            {this.state.currentExpense
                                                ? <Button type='danger' onClick={this.cancel_update.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                                    Cancelar
                                                </Button>
                                                : ''
                                            }
                                        </div>
                                    </Form>
                                </div>

                            </div>
                        </div>

                        <div className="col-md-8">
                            <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>

                                <div className="box-body">
                                    <div className="table-responsive table">

                                        <InfiniteScroll
                                            padding={50}
                                            throttle={100}
                                            onScroll={() => this.loadMore()}>

                                            <Table 
                                                dataSource={this.props.paymentType.paymentTypes} 
                                                rowKey="objectId" size="middle" 
                                                loading={this.props.app.loadingTable} 
                                                pagination={false}>
                                                
                                                <Column title="Nombre" dataIndex="name" key="name" />
                                                {/*<Column title="Descripción" dataIndex="description" key="description" />*/}
                                                {!this.state.currentHotel
                                                    ? <Column title="Hotel" key="hotel" render={(item) => (
                                                        <span>{item.hotel ? item.hotel.name : '-'}</span>
                                                    )} />
                                                    : ''
                                                }
                                                <Column title="Acciones" key="action"
                                                    render={(item) => (
                                                        <span className="actions">
                                                            <ButtonGroup>
                                                                <Tooltip placement="bottom" title="Editar">
                                                                    <Button>
                                                                        <Link onClick={() => { this.setUpdate(item) }}><Icon name="edit" /></Link>
                                                                    </Button>
                                                                </Tooltip>

                                                                {(item.children && item.children.length === 0) || !item.children
                                                                    ?<Tooltip placement="bottom" title="Eliminar">
                                                                        <Button>
                                                                            <Link onClick={() => { this.delete_item(item) }} className=""><Icon name="trash" /></Link>
                                                                        </Button>
                                                                    </Tooltip>
                                                                    : ''
                                                                }
                                                            </ButtonGroup>
                                                        </span>
                                                    )}
                                                />
                                            </Table>        
                                        </InfiniteScroll>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

export default connect(({paymentType, app}) => ({paymentType, app}))(Form.create()(paymentType))


// WEBPACK FOOTER //
// ./src/components/catalogs/payments.js